module.exports = __webpack_public_path__ + "img/girl-with-phone.2f17ced4.png";